/** Public legal documents shipped with the cabinet UI. */
export const USER_AGREEMENT_PDF = '/legal/user-agreement.pdf';
export const PDN_CONSENT_PDF = '/legal/soglasie-na-obrabotku-pdn.pdf';
